const LANGUAGE = {
  PL: {
    symbol: 'pl',
  },
  EN: {
    symbol: 'en',
  },
  RO: {
    symbol: 'ro',
  },
  SK: {
    symbol: 'sk',
  },
  DE: {
    symbol: 'de',
  },
  // FR: {
  //   symbol: 'fr',
  // },
  // ES: {
  //   symbol: 'es',
  // },
  // CZ: {
  //   symbol: 'cz',
  // },
  // IT: {
  // IT: {
  //   symbol: 'it',
  // },
  // FI: {
  //   symbol: 'fi',
  // },
  // SE: {
  //   symbol: 'se',
  // },
};

const DEFAULT_LANG = LANGUAGE.EN;

export {
  LANGUAGE as default,
  DEFAULT_LANG,
};



// WEBPACK FOOTER //
// ./src/const/lang.js